import request from "@/utils/request";
// 网页游戏列表
const getWebGameList = (params) =>
  request.post("/laiHi/web/webGame/pageWebGame", params);
// 添加或修改网页游戏
const setWebGame = (params) =>
  request.post("/laiHi/web/webGame/addModifyWebGame", params);
// 删除网页游戏
const deleteWebGame = (params) =>
  request.post("/laiHi/web/webGame/deletedWebGame", params);
// 获取网页游戏信息
const getWebGameItem = (params) =>
  request.post("/laiHi/web/webGame/getWebGameInfo", params);
// 修改网页游戏状态
const editWebGameStatus = (params) =>
  request.post("/laiHi/web/webGame/modifyWebGameStatus", params);
export {
  getWebGameList,
  setWebGame,
  deleteWebGame,
  getWebGameItem,
  editWebGameStatus,
};
